<template>
  <el-table
    :data="list"
    style="width: 100%"
    :header-cell-style="{ background: '#F3F3F3' }"
    size="small"
  >
    <el-table-column label="序号" type="index" width="50"/>
    <el-table-column label="分区" property="" min-width="200">
      <template slot-scope="scope">
        {{ joinRegionName(scope.row) }}
      </template>
    </el-table-column>
    <template v-if="tableHeaderList.length">
      <template v-for="(item,index) in tableHeaderList">
        <el-table-column
          :label="item.label"
          :key="index"
          :min-width="getStyleAttribute(item.customStyle,'minWidth')"
          :width="getStyleAttribute(item.customStyle,'width')"
          :align="getStyleAttribute(item.customStyle,'align')"
        >
          <template slot-scope="scope">
            {{ scope.row[item.valueKey]||"-" }}
          </template>
        </el-table-column>
      </template>
    </template>
    <el-table-column label="MINMAL(低消)" property="minimalPrice" width="140" v-if="isLowElimination"/>
    <el-table-column label="整体时效" property="" width="160">
      <template slot-scope="scope">
        {{scope.row.agingFrom||""}}—{{scope.row.agingTo||""}} {{["","自然日","工作日"][scope.row.agingType]||""}}
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import {isObject} from "my-tools-kit";

export default {
  name: "quotationTableList",
  props:{
    list:{
      type:Array,
      default:()=>[],
    },
    tableHeaderList:{
      type:Array,
      default:()=>[
        {
          label:"区间1",
          valueKey:"price1",
          customStyle:{
            minWidth:"140",
            width:"140",
            align:"center",
          },
        },
      ],
    },
    partitionType:[String,Number],//分区类型：1 公里  2 城市邮编 3 FBA仓代码
    isLowElimination:Boolean,//是否低消 true 是 false 否
  },
  methods:{
    getStyleAttribute(obj={},key=""){
      if(!isObject(obj)) return "";
      if(!key) return "";
      return obj[key]||"";
    },
    joinRegionName(item = {}){
      if(`${this.partitionType}` === "1"){
        let nameText = "";
        let start = item.segmentStart === 0 || item.segmentStart ? item.segmentStart : "";
        let end = item.segmentEnd||"";
        if(end){
          nameText = `${start}—${end}MILE`;
        }else{
          nameText = `${start}MILE +`;
        }
        return nameText;
      }else{
        return item.partitionName || ""
      }
    },
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/QuotationManagement/components-productQuotation/usePlatformQuotation/quotationTableList.vue